var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoClearWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        mask: url(#mask);\n      }\n\n      .st1 {\n        filter: url(#luminosity-invert-noclip);\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert-noclip",
    x: 11.2,
    y: 131.7,
    width: 1002.4,
    height: 550.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "cm",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 11.2,
    y: 131.7,
    width: 1002.4,
    height: 550.3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.2,626.6c-29-1.5-50.1-9.5-63.1-23.8-13.1-14.3-20-37-20.9-67.9-.3-19.1-.6-38.5-.6-58.3,0-19.7-.1-39.5-.1-59.4s0-39.7.1-59.4c0-19.7.3-39.2.6-58.5.9-30.7,7.8-53.2,20.9-67.5,13.1-14.3,34.1-22.1,63.1-23.7v53.5c-6.3,1.5-11.1,4.5-14.3,8.8-3.2,4.4-5,10.2-5.4,17.5-.7,19.5-1.2,40.1-1.5,62-.3,21.9-.5,44.1-.5,66.8s.2,45,.5,67c.3,21.9.9,42.8,1.5,62.6.3,7.3,2.1,13.2,5.4,17.7,3.2,4.4,8,7.4,14.3,9v53.5ZM180.8,626.6v-53.5c6.5-1.5,11.3-4.5,14.5-9,3.2-4.4,4.8-10.3,5-17.7.9-19.8,1.4-40.7,1.7-62.6.3-21.9.4-44.3.4-67s-.2-45-.5-66.8c-.3-21.8-.9-42.5-1.5-62-.2-7.3-1.9-13.1-5.1-17.4-3.2-4.3-8-7.3-14.3-9v-53.5c29,1.5,49.9,9.5,62.6,23.9,12.7,14.4,19.5,36.8,20.4,67.2.5,19.5.9,39,1.2,58.8.3,19.7.4,39.5.4,59.4s-.1,39.6-.4,59.3c-.3,19.6-.6,39-1.2,58.1-.9,30.7-7.6,53.3-20.4,67.6-12.7,14.3-33.6,22.4-62.6,24.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.4,622.3V212.6h64v409.7h-64ZM401.2,483.2v-56.6h2.3c10.9,0,19.1-2.6,24.6-7.7,5.5-5.1,8.5-12.5,9-22.3.5-9.9.9-20.5,1-31.9.2-11.4.2-22.7,0-33.9-.2-11.3-.5-21.9-1-32-.5-9.7-3.5-17.2-8.8-22.3-5.4-5.1-13.5-7.7-24.5-7.7h-2.6v-56.3h2.6c33.6,0,58,7,73,20.9,15,13.9,23,36.8,24.1,68.8.7,16.9,1,32.4,1,46.5s-.3,29-1,44.7c-1,32.1-9.1,55.1-24.2,69-15.1,13.9-39.5,20.9-73.1,20.9h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M541.1,622.3V212.6h64v409.7h-64ZM629.6,268.9v-56.3h70.4v56.3h-70.4ZM629.6,442.8v-56.3h65.3v56.3h-65.3ZM629.6,622.3v-56.3h70.4v56.3h-70.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M849.9,622.3l-27.9-138-23.8-215.6h-59.4v-56.1h96.5l26.9,130.3,30.5,223h57.9v56.3h-100.6ZM738.7,622.3v-330.3h42l14.6,192.6,5.4,137.8h-62ZM909,542.4l-17.4-197.2-3.1-132.6h62v329.8h-41.5Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.6,889.4h-9.4c-.8-1.7-1.3-9.2-1.5-23.5-5.2,10.1-16.8,25.2-47.4,25.2s-63.8-32.1-63.8-73.9,23.1-76.8,66.1-76.8,52.7,16.6,57.3,43.7h-11.3c-6.3-20.8-20.8-33.2-46.4-33.2-36.7,0-53.5,28.5-53.5,65.7s16.2,64,52,64,47-23.9,47-56.5v-1.7h-47.4v-10.5h58.3v77.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.5,814.9c0,40.1-21.4,76.6-66.7,76.6s-65.5-33.4-65.5-75.6,23.3-75.6,66.9-75.6,65.3,31.7,65.3,74.5ZM192.4,815.3c0,33.8,18.7,65.7,53.9,65.7s53.9-31.1,53.9-65.9-18-64.2-53.5-64.2-54.4,31.3-54.4,64.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M355.3,742.5h11.3v136.4h78.9l-2.1,10.5h-88.1v-146.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.7,742.5h89v10.5h-77.7v55.4h72.8v10.5h-72.8v70.5h-11.3v-146.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M670.3,849.9c4.4,19.5,17.4,31.1,41.6,31.1s37.1-13.4,37.1-29.4-7.3-26.9-39.7-34.8c-31.1-7.8-44.5-17.8-44.5-39s14.1-37.4,45.5-37.4,46,19.7,47.9,37.6h-11.8c-3.4-15.7-13.6-27.1-36.7-27.1s-32.7,9.9-32.7,26.2,9.7,22.5,36.7,29.2c41.3,10.3,47.4,26.9,47.4,44.5s-15.7,40.3-49.7,40.3-50.2-21.4-52.9-41.1h11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M815.1,742.5v146.9h-11.3v-146.9h11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M996,821.8c0-28.8.2-56.2.8-70.9h-.6c-5.9,19.7-35.7,92.1-54.4,138.5h-11.1c-14.1-35.9-44.9-116.5-51.6-138.7h-.4c1,16.8,1.5,51,1.5,76.2v62.5h-11.3v-146.9h17c20.1,50.4,45.5,116.3,51,132.8h.4c3.4-10.7,32.7-83.9,53.3-132.8h16.8v146.9h-11.3v-67.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 11.2,
    y: 131.7,
    width: 1002.4,
    height: 550.3,
    rx: 50,
    ry: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClearWhite);
export default __webpack_public_path__ + "static/media/logo-clear-white.992958b8265b29dc5d8ca67eb1ee77ee.svg";
export { ForwardRef as ReactComponent };